"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUtilityLogic = void 0;
var rdflib_1 = require("rdflib");
var CustomError_1 = require("../logic/CustomError");
var debug = __importStar(require("../util/debug"));
var utils_1 = require("./utils");
function createUtilityLogic(store, aclLogic, containerLogic) {
    function recursiveDelete(url) {
        return __awaiter(this, void 0, void 0, function () {
            var aclDocUrl, containerMembers, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        if (!containerLogic.isContainer(url)) return [3 /*break*/, 5];
                        return [4 /*yield*/, aclLogic.findAclDocUrl(url)];
                    case 1:
                        aclDocUrl = _a.sent();
                        return [4 /*yield*/, store.fetcher._fetch(aclDocUrl, { method: "DELETE" })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, containerLogic.getContainerMembers(url)];
                    case 3:
                        containerMembers = _a.sent();
                        return [4 /*yield*/, Promise.all(containerMembers.map(function (url) { return recursiveDelete(url); }))];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, store.fetcher._fetch(url, { method: "DELETE" })];
                    case 6:
                        e_1 = _a.sent();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * Create a resource if it really does not exist
     * Be absolutely sure something does not exist before creating a new empty file
     * as otherwise existing could  be deleted.
     * @param doc {NamedNode} - The resource
     */
    function loadOrCreateIfNotExists(doc) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1, err_2, msg, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 10]);
                        return [4 /*yield*/, store.fetcher.load(doc)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 10];
                    case 2:
                        err_1 = _a.sent();
                        if (!(err_1.response.status === 404)) return [3 /*break*/, 8];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, store.fetcher.webOperation('PUT', doc, { data: '', contentType: 'text/turtle' })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_2 = _a.sent();
                        msg = 'createIfNotExists: PUT FAILED: ' + doc + ': ' + err_2;
                        throw new CustomError_1.WebOperationError(msg);
                    case 6: return [4 /*yield*/, store.fetcher.load(doc)];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        if (err_1.response.status === 401) {
                            throw new CustomError_1.UnauthorizedError();
                        }
                        if (err_1.response.status === 403) {
                            if ((0, utils_1.differentOrigin)(doc)) {
                                throw new CustomError_1.CrossOriginForbiddenError();
                            }
                            throw new CustomError_1.SameOriginForbiddenError();
                        }
                        msg = 'createIfNotExists doc load error NOT 404:  ' + doc + ': ' + err_1;
                        throw new CustomError_1.FetchError(err_1.status, err_1.message + msg);
                    case 9: return [3 /*break*/, 10];
                    case 10: return [2 /*return*/, response];
                }
            });
        });
    }
    /* Follow link from this doc to another thing, or else make a new link
    **
    ** @returns existing object, or creates it if non existent
    */
    function followOrCreateLink(subject, predicate, object, doc) {
        return __awaiter(this, void 0, void 0, function () {
            var result, msg, err_3, msg, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store.fetcher.load(doc)];
                    case 1:
                        _a.sent();
                        result = store.any(subject, predicate, null, doc);
                        if (result)
                            return [2 /*return*/, result];
                        if (!store.updater.editable(doc)) {
                            msg = "followOrCreateLink: cannot edit ".concat(doc.value);
                            debug.warn(msg);
                            throw new CustomError_1.NotEditableError(msg);
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, store.updater.update([], [(0, rdflib_1.st)(subject, predicate, object, doc)])];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _a.sent();
                        msg = "followOrCreateLink: Error making link in ".concat(doc, " to ").concat(object, ": ").concat(err_3);
                        debug.warn(msg);
                        throw new CustomError_1.WebOperationError(err_3);
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, loadOrCreateIfNotExists(object)
                            // store.fetcher.webOperation('PUT', object, { data: '', contentType: 'text/turtle'})
                        ];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        err_4 = _a.sent();
                        debug.warn("followOrCreateLink: Error loading or saving new linked document: ".concat(object, ": ").concat(err_4));
                        throw err_4;
                    case 8: return [2 /*return*/, object];
                }
            });
        });
    }
    // Copied from https://github.com/solidos/web-access-control-tests/blob/v3.0.0/test/surface/delete.test.ts#L5
    function setSinglePeerAccess(options) {
        return __awaiter(this, void 0, void 0, function () {
            var str, aclDocUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        str = [
                            '@prefix acl: <http://www.w3.org/ns/auth/acl#>.',
                            '',
                            "<#alice> a acl:Authorization;\n  acl:agent <".concat(options.ownerWebId, ">;"),
                            "  acl:accessTo <".concat(options.target, ">;"),
                            "  acl:default <".concat(options.target, ">;"),
                            '  acl:mode acl:Read, acl:Write, acl:Control.',
                            ''
                        ].join('\n');
                        if (options.accessToModes) {
                            str += [
                                '<#bobAccessTo> a acl:Authorization;',
                                "  acl:agent <".concat(options.peerWebId, ">;"),
                                "  acl:accessTo <".concat(options.target, ">;"),
                                "  acl:mode ".concat(options.accessToModes, "."),
                                ''
                            ].join('\n');
                        }
                        if (options.defaultModes) {
                            str += [
                                '<#bobDefault> a acl:Authorization;',
                                "  acl:agent <".concat(options.peerWebId, ">;"),
                                "  acl:default <".concat(options.target, ">;"),
                                "  acl:mode ".concat(options.defaultModes, "."),
                                ''
                            ].join('\n');
                        }
                        return [4 /*yield*/, aclLogic.findAclDocUrl(options.target)];
                    case 1:
                        aclDocUrl = _a.sent();
                        return [2 /*return*/, store.fetcher._fetch(aclDocUrl, {
                                method: 'PUT',
                                body: str,
                                headers: [
                                    ['Content-Type', 'text/turtle']
                                ]
                            })];
                }
            });
        });
    }
    function createEmptyRdfDoc(doc, comment) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store.fetcher.webOperation("PUT", doc.uri, {
                            data: "# ".concat(new Date(), " ").concat(comment, "\n  "),
                            contentType: "text/turtle",
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        recursiveDelete: recursiveDelete,
        setSinglePeerAccess: setSinglePeerAccess,
        createEmptyRdfDoc: createEmptyRdfDoc,
        followOrCreateLink: followOrCreateLink,
        loadOrCreateIfNotExists: loadOrCreateIfNotExists
    };
}
exports.createUtilityLogic = createUtilityLogic;
//# sourceMappingURL=utilityLogic.js.map